import React, { useEffect } from 'react'
import { View, TouchableOpacity, Text, Image, StyleSheet } from "react-native"
import { FONT_STYLE } from "../../dataSchema/const"

const ResultPopUpSucccess = ({ requestClose, isZmp }) => {
  useEffect(()=>{
    console.log('[ResultPopUpSuccess] mounted, isZmp=', isZmp)
  }, [isZmp])

  return (
    <View style={styles.popup}>
      <Image style={styles.image} source={require('../../assets/Congrat.png')}></Image>
      <Text style={styles.popupText}>{'Yay, hoàn thành khảo sát rồi'}</Text>
      {isZmp ? (
        <Text style={styles.contentText}>{'Hãy trở về TAPTAP Mini app để tận hưởng thêm nhiều niềm vui và quà tặng đang chờ bạn!'}</Text>
      ) : (
        <Text style={styles.contentText}>{'Cảm ơn bạn đã dành thời gian cho chúng tôi\nChúc bạn và gia đình một ngày tốt lành!'}</Text>
      )}

      {!isZmp && (
        <TouchableOpacity
          style={styles.closeButton}
          onPress={requestClose}
        >
          <Text style={styles.closeButtonText}>Đóng</Text>
        </TouchableOpacity>
      )}
    </View>
  )
}

const styles = StyleSheet.create({
  image: {
    width: 183,
    height: 130,
    top: -55
  },
  popup: {
    width: 343,
    height: 330,
    backgroundColor: '#FFFFFF',
    borderRadius: 10,
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  popupText: {
    fontSize: 22,
    fontFamily: FONT_STYLE.BOLD,
    width: '60%',
    textAlign: 'center',
    top: -30
  },
  contentText: {
    fontSize: 14,
    fontFamily: FONT_STYLE.MEDIUM,
    textAlign: 'center',
    width: '100%',
    top: -10
  },
  closeButton: {
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 5,
    borderWidth: 1,
    borderColor: '#888888',
    width: '90%',
    position: 'absolute',
    bottom: 25
  },
  closeButtonText: {
    color: '#000000',
    fontSize: 16,
    fontFamily: FONT_STYLE.BOLD,
    textAlign: 'center'
  },
})
export default ResultPopUpSucccess